import React from 'react'
import ArrowBackIcon from '@mui/icons-material/ArrowBack'
import { Box, IconButton, Stack, Typography } from '@mui/material'

import { ProfileView } from '@/src/components/desktop/accounts/profile/profile'
import { ProfileData } from '@/src/types/profile'

interface MobileProfileViewProps {
    t: (key: string) => string
    profile: ProfileData
    fullName: string
    initials: string
    phoneLabel: string
    dateOfBirthValue: string
    onBack: () => void
    onEdit: () => void
    isRtl: boolean
}

const MobileProfileView: React.FC<MobileProfileViewProps> = ({
    t,
    profile,
    fullName,
    initials,
    phoneLabel,
    dateOfBirthValue,
    onBack,
    onEdit,
    isRtl
}) => {
    return (
        <Box sx={{ minHeight: '100dvh', bgcolor: 'background.default' }}>
            <Stack
                direction="row"
                alignItems="center"
                justifyContent="space-between"
                sx={{ borderBottom: 1, borderColor: 'divider', px: 2, py: 1.5, position: 'relative' }}
            >
                <IconButton aria-label={t('title')} onClick={onBack} sx={{ ml: -1 }}>
                    <ArrowBackIcon sx={{ fontSize: 20, transform: isRtl ? 'scaleX(-1)' : 'none' }} />
                </IconButton>
                <Typography
                    variant="h6"
                    sx={{ fontWeight: 700, fontSize: '16px', position: 'absolute', left: '50%', transform: 'translateX(-50%)' }}
                >
                    {t('title')}
                </Typography>
                <Box sx={{ width: 40 }} />
            </Stack>

            <Box sx={{ px: 1.5, py: 2 }}>
                <ProfileView
                    profile={profile}
                    onEdit={onEdit}
                    t={t}
                    dateOfBirthValue={dateOfBirthValue}
                    fullName={fullName}
                    initials={initials}
                    phoneLabel={phoneLabel}
                    hideTitle
                />
            </Box>
        </Box>
    )
}

export { MobileProfileView }
export default MobileProfileView
export type { MobileProfileViewProps }
